import { FC } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { CustomerAddress } from '@models';
import { AddressView } from './AddressView';

type Props = {
  address: CustomerAddress;
};

export const AddressListItem: FC<Props> = ({ address }) => {
  const getState = () => {
    const stateAbb = address.form_fields?.find((val) => val.name === 'State Abbreviation');

    return stateAbb ? `${stateAbb.value} - ` : '';
  };

  return (
    <Accordion data-testid="address-list-item">
      <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls={`${address.id}-content`} id={`${address.id}-header`}>
        <Typography data-testid="full-address-text">
          {address.address2.trim() !== '' && `${address.address2.trim()}, `}
          {address.address1.trim()}, {address.city.trim()}, {getState()}
          {address.postal_code} {address.country}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>{<AddressView address={address} />}</AccordionDetails>
    </Accordion>
  );
};
